export var seccions = {
  // Reportes
  ejecuciones: {
    orden:'No.',
    evaluacion:'Evaluación',
    av:'Área de ventas',
    cliente:'Almacenista',
    evaluador:'Evaluador',
    fecha_de_ejecucion:'Fecha de ejecución',
    fecha_de_modificacion:'Ultima modificación',
    ie:'IE',
  },
  binarios: {
    orden:'No.',
    nombre:'Nombre',
    fecha_creacion:'Fecha',
    de_fecha:'Desde',
    hasta_fecha:'Hasta',
  },
  reportes_de_cedis: {
    orden:'No.',
    nombre:'Nombre',
    fecha_creacion:'Fecha',
    de_fecha:'Desde',
    hasta_fecha:'Hasta',
  },
  // Datos
  categorias: {
    nombre:'Nombre',
  },
  sub_categorias: {
    nombre:'Nombre',
  },
  evaluaciones: {
    nombre:'Nombre',
    fecha_de_creacion:'Fecha de creación',
    activo:'Activa',
  },
  oficinas_de_ventas: {
    nombre:'Nombre',
    trabajador:'Cedis',
  },
  areas_de_ventas: {
    nombre:'Nombre',
  },
  almacenistas: {
    nombre:'Nombre',
    apellido:'Apellido',
    ofv:'Oficina de ventas',
    av:'Área de ventas',
    cedis:'Cedis',
  },
  cedis: {
    nombre:'Nombre',
    // av:'Area de ventas',
    // coordinador:'Coordinador',
  },
  evaluadores: {
    usuario:'Nombre de usuario',
    nombre:'Nombre',
    apellido:'Apellido',
    telefono:'Telefono',
    email:'Correo Electrónico',
    activo:'Activo',
  },
  
}
